import styled, { css } from 'styled-components'

export interface CardProps {
  padding?: 'sm' | 'md' | 'lg'
  elevated?: boolean
}

export const Card = styled.div<CardProps>`
  background-color: ${({ theme }) => theme.component.card.backgroundColor};
  border: ${({ theme }) => theme.component.card.border};
  border-radius: ${({ theme }) => theme.component.card.borderRadius};
  
  ${({ padding = 'md', theme }) => {
    switch (padding) {
      case 'sm':
        return css`padding: ${theme.spacing[40]};`
      case 'lg':
        return css`padding: ${theme.spacing[80]};`
      default:
        return css`padding: ${theme.spacing[60]};`
    }
  }}
  
  ${({ elevated, theme }) => 
    elevated && 
    css`box-shadow: ${theme.component.card.boxShadow};`
  }
`

export default Card